// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1cZeC","selects":"Documents_selects__12Ih9"};